import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PoliciesType } from './RoleType';
import { OAuthGuard, ODefaultComponent } from '@olameter/o-authentication';
import { OCallbackComponent, OPopLoginComponent } from '@olameter/o-authentication';
import { ORoleGuard , popLoginPath, callbackPath} from '@olameter/o-authentication';

enum PathMatch {
  full = 'full',
  prefix = 'prefix',
}


const routes = [
  {
    path: '',
    component: HomeComponent,
    isVisibileInMenu: false,
    pathMatch: PathMatch.full,
    canActivate: [OAuthGuard, ORoleGuard],
    data: { policies: [PoliciesType.ForRead] },
  },
  {
    path: 'details/:woid',
    isVisibileInMenu: false,
    pathMatch: PathMatch.full,
    canActivate: [OAuthGuard, ORoleGuard],
    data: { policies: [PoliciesType.ForRead] },
    loadChildren: () =>
      import('./details-workorder/details-workorder.module').then(
        (m) => m.DetailsWorkorderModule
      ),
  },
  {
    path: 'helpdesk',
    loadChildren: () =>
      import('./twilio-helpdesk/twilio-helpdesk.module').then(
        (m) => m.TwilioHelpDeskModule
      ),
    text: 'twilio-helpdesk',
    isVisibileInMenu: true,
    icon: 'far fa-project-diagram',
    data: {
      roles: [],
    },
  },
  {
    path: callbackPath,
    component: OCallbackComponent,
    isVisibileInMenu: false,
  },
  {
    path: popLoginPath,
    component: OPopLoginComponent,
    isVisibileInMenu: false,
  },
  {
    path: '**',
    component: ODefaultComponent,
    isVisibleInMenu: false,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
